import { IterableX } from './iterablex';

export class SkipLastIterable<TSource> extends IterableX<TSource> {
  private _source: Iterable<TSource>;
  private _count: number;

  constructor(source: Iterable<TSource>, count: number) {
    super();
    this._source = source;
    this._count = count;
  }

  *[Symbol.iterator]() {
    let q = [] as TSource[];
    for (let item of this._source) {
      q.push(item);
      if (q.length > this._count) {
        yield q.shift()!;
      }
    }
  }
}

export function skipLast<TSource>(source: Iterable<TSource>, count: number): IterableX<TSource> {
  return new SkipLastIterable<TSource>(source, count);
}



// WEBPACK FOOTER //
// ./node_modules/ix/iterable/skiplast.ts